/**
 * Función que minimiza el DSA después de que el usuario hace dos veces scroll
 */

export function scrollToDSA(distance = 0, whitoutEvent = false) {
  console.log(distance)

  let btnToCloseDSA = null
  const waitForDSA = setInterval(() => {
    if (
      typeof window.DSA !== 'undefined' &&
      document.readyState === 'complete' &&
      document.getElementById('dsa-newId')
    ) {
      clearInterval(waitForDSA)
      btnToCloseDSA = document.querySelector('.dsa-close-icon')

      if (whitoutEvent) btnToCloseDSA.click()
    }
  }, 50)

  window.addEventListener('scroll', () => {
    if (window.scrollY >= distance) {
      if (btnToCloseDSA !== null) {
        btnToCloseDSA.click()
      }
    }
  })
}

export function minimizedDSA() {
  let btnToCloseDSA = null
  const waitForDSA = setInterval(() => {
    if (
      typeof window.DSA !== 'undefined' &&
      document.readyState === 'complete' &&
      document.getElementById('dsa-newId')
    ) {
      clearInterval(waitForDSA)
      btnToCloseDSA = document.querySelector('.dsa-close-icon')

      btnToCloseDSA.click()
    }
  }, 50)
}
// export function newPuertas() {
//   const style = document.createElement('style');
//   style.innerHTML = `
//       #mensajeDescuento {
//           background-color: #80ba27; /* Color de fondo verde */
//           color: #000; /* Color del texto */
//           padding: 10px;
//           text-align: center;
//           font-weight: bold;
//           position: fixed; /* Asegura que el mensaje esté fijo */
//           width: 100%;
//           top: 121px; /* Ajustar según la altura de tu header */
//           z-index: 1000; /* Asegura que esté sobre otros elementos */
//           font-family: "Nombre de la fuente", sans-serif; /* Cambia esto a la fuente utilizada en tu sitio */
//       }
//       #mensajeDescuento p {
//           margin: 0;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           font-size: 16px;
//           font-style: italic; /* Texto en cursiva */
//       }
//       #mensajeDescuento b {
//           font-style: normal; /* Texto en negrita y normal */
//       }
//       #mensajeDescuento button {
//           background-color: #FFFFFF; /* Fondo blanco */
//           color: #000000; /* Letra en negro */
//           font-weight: bold; /* Letra en negrita */
//           border: none;
//           padding: 5px 10px; /* Botón más pequeño */
//           text-decoration: none;
//           font-size: 14px; /* Fuente más pequeña */
//           border-radius: 5px;
//           cursor: pointer;
//           margin-left: 10px; /* Añadir espacio entre el texto y el botón */
//           font-family: "Nombre de la fuente", sans-serif; /* Cambia esto a la fuente utilizada en tu sitio */
//       }
//       #mensajeDescuento button:hover {
//           background-color: #f0f0f0; /* Fondo gris claro al pasar el ratón */
//       }
//       #mensajeDescuento .close-button {
//           background: none;
//           border: none;
//           font-size: 16px;
//           font-weight: bold;
//           cursor: pointer;
//           color: #000;
//           margin-left: 10px; /* Añadir espacio entre el botón de reserva y el botón de cierre */
//       }
//       /* Media query para dispositivos móviles */
//       @media (max-width: 768px) {
//           #mensajeDescuento {
//               display: none!important;
//           }
//       }
//   `;
//   document.head.appendChild(style);

//   // Verificar la URL para excluir ciertas páginas
//   const excludedPaths = [
//     '/blog',
//     '/noticias',
//     '/premios',
//     '/preguntas-frecuentes',
//     '/quienes-somos',
//     '/proyecto-educativo',
//     '/como-aprendes',
//     '/empresas',
//     '/nuestros-centros',
//     '/becas',
//     '/ventajas-ser-alumno-ifp',
//     '/empleos-fp',
//     '/opiniones',
//     '/proyectos-alumnos',
//     '/preguntes-frequents',
//     '/qui-som',
//     '/projecte-educatiu',
//     '/com-aprens',
//     '/empreses',
//     '/els-nostres-centres',
//     '/beques-i-ajuts',
//     '/avantatges-dels-nostres-alumnes',
//     '/opinions'
//   ];
  
  
//   if (excludedPaths.includes(window.location.pathname)) {
//     return;
//   }

//   // Crear el mensaje de descuento
//   const mensajeDescuento = document.createElement('div');
//   mensajeDescuento.id = 'mensajeDescuento';
  
//   const texto = document.createElement('p');

//   // Condicionar según la URL
//   if (window.location.href.includes('ifp.es/ca/')) {
//     texto.innerHTML = 'No et quedis sense la teva plaça: 5% de descompte en el teu cicle i no paguis fins Setembre.';
//   } else {
//     texto.innerHTML = '¡Últimas Plazas! A partir del 5% de descuento en tu ciclo y no pagues hasta Septiembre.';
//   }
  
//   const boton = document.createElement('button');
//   if (window.location.href.includes('ifp.es/ca/')) {
//     boton.textContent = 'Reserva la teva plaça';
//   } else {
//     boton.textContent = 'Reserva tu Plaza';
//   }
//   boton.onclick = function() {
//     const elemento = document.getElementById('block-header-form-si').getElementsByTagName('button').item(0);
//     if (elemento) {
//       elemento.click();
//     } else {
//       console.error('No se pudo encontrar el botón para abrir el modal.');
//     }
//   };

//   // Crear el botón de cierre
//   const closeButton = document.createElement('button');
//   closeButton.className = 'close-button';
//   closeButton.innerHTML = '&times;';
//   closeButton.onclick = function() {
//     mensajeDescuento.style.display = 'none';
//   };
  
//   texto.appendChild(boton);
//   texto.appendChild(closeButton);
//   mensajeDescuento.appendChild(texto);
//   document.body.appendChild(mensajeDescuento);
  
//   mensajeDescuento.style.display = 'block';
// }

export function newPuertas() {
  const style = document.createElement('style');

  // Determinar el valor de 'top' según la URL
  let topValue = '121px';
  if (window.location.href.includes('landing')) {
    topValue = '70px';
  }

  style.innerHTML = `
      #mensajeDescuento {
          background-color: #80ba27; /* Color de fondo verde */
          color: #000; /* Color del texto */
          padding: 10px;
          text-align: center;
          font-weight: bold;
          position: fixed; /* Asegura que el mensaje esté fijo */
          width: 100%;
          top: ${topValue}; /* Ajuste dinámico según la URL */
          z-index: 1000; /* Asegura que esté sobre otros elementos */
          font-family: "Nombre de la fuente", sans-serif; /* Cambia esto a la fuente utilizada en tu sitio */
      }
      #mensajeDescuento p {
          margin: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          font-style: italic; /* Texto en cursiva */
      }
      #mensajeDescuento b {
          font-style: normal; /* Texto en negrita y normal */
      }
      #mensajeDescuento button {
          background-color: #FFFFFF; /* Fondo blanco */
          color: #000000; /* Letra en negro */
          font-weight: bold; /* Letra en negrita */
          border: none;
          padding: 5px 10px; /* Botón más pequeño */
          text-decoration: none;
          font-size: 14px; /* Fuente más pequeña */
          border-radius: 5px;
          cursor: pointer;
          margin-left: 10px; /* Añadir espacio entre el texto y el botón */
          font-family: "Nombre de la fuente", sans-serif; /* Cambia esto a la fuente utilizada en tu sitio */
      }
      #mensajeDescuento button:hover {
          background-color: #f0f0f0; /* Fondo gris claro al pasar el ratón */
      }
      #mensajeDescuento .close-button {
          background: none;
          border: none;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          color: #000;
          margin-left: 10px; /* Añadir espacio entre el botón de reserva y el botón de cierre */
      }
      /* Media query para dispositivos móviles */
      @media (max-width: 768px) {
          #mensajeDescuento {
              display: none!important;
          }
      }
  `;
  document.head.appendChild(style);

  // Verificar la URL para excluir ciertas páginas
  const excludedPaths = [
    '/blog',
    '/noticias',
    '/premios',
    '/preguntas-frecuentes',
    '/quienes-somos',
    '/proyecto-educativo',
    '/como-aprendes',
    '/empresas',
    '/nuestros-centros',
    '/becas',
    '/ventajas-ser-alumno-ifp',
    '/empleos-fp',
    '/opiniones',
    '/proyectos-alumnos',
    '/preguntes-frequents',
    '/qui-som',
    '/projecte-educatiu',
    '/com-aprens',
    '/empreses',
    '/els-nostres-centres',
    '/beques-i-ajuts',
    '/avantatges-dels-nostres-alumnes',
    '/opinions'
  ];

  if (excludedPaths.includes(window.location.pathname)) {
    return;
  }

  // Crear el mensaje de descuento
  const mensajeDescuento = document.createElement('div');
  mensajeDescuento.id = 'mensajeDescuento';
  
  const texto = document.createElement('p');

  // Condicionar según la URL
  if (window.location.href.includes('ifp.es/ca/')) {
    texto.innerHTML = "ÚLTIMES PLACES! Matricula't ARA i comença a pagar al Novembre";
  } else {
    texto.innerHTML = '¡ÚLTIMAS PLAZAS!  Matricúlate AHORA y empieza a pagar en noviembre.';
  }
  
  const boton = document.createElement('button');
  if (window.location.href.includes('ifp.es/ca/')) {
    boton.textContent = 'Reserva la teva plaça';
  } else {
    boton.textContent = 'Reserva tu Plaza';
  }
  boton.onclick = function() {
    const elemento = document.getElementById('block-header-form-si').getElementsByTagName('button').item(0);
    if (elemento) {
      elemento.click();
    } else {
      console.error('No se pudo encontrar el botón para abrir el modal.');
    }
  };

  // Crear el botón de cierre
  const closeButton = document.createElement('button');
  closeButton.className = 'close-button';
  closeButton.innerHTML = '&times;';
  closeButton.onclick = function() {
    mensajeDescuento.style.display = 'none';
  };
  
  texto.appendChild(boton);
  texto.appendChild(closeButton);
  mensajeDescuento.appendChild(texto);
  document.body.appendChild(mensajeDescuento);
  
  mensajeDescuento.style.display = 'block';
}



